<router-outlet />

@if (bookingConfirmation.status(); as status) {
  <agj-booking-confirmation
    [status]="status"
    [errorKind]="bookingConfirmation.errorKind()"
    [details]="bookingConfirmation.details()"
    [errorTitle]="bookingConfirmation.errorTitle()"
    [errorCopy]="bookingConfirmation.errorCopy()"
    [successTitle]="bookingConfirmation.successTitle()"
    [successTitleLine2]="bookingConfirmation.successTitleLine2()"
    [showBackButton]="status === 'error' && bookingConfirmation.errorKind() === 'generic'"
    [leaving]="bookingConfirmation.leaving()"
    (back)="bookingConfirmation.close()"
    (requestAccess)="bookingConfirmation.requestAccess()"
  ></agj-booking-confirmation>
}

<!-- Filtros SVG do tema (wordmark da Lottie no escuro). Uma vez só no app. -->
<agj-one-svg-defs />

<!-- Contato da empresa para quando o app não sobe (iPhone 6). Fica escondido; ver src/index.html (vigia de boot). -->
<agj-boot-fallback />
